module.exports = __webpack_public_path__ + "img/commander11.png";